import { computed } from "vue";
import { useWindowSize } from "@vueuse/core";
import defaultTheme from "tailwindcss/defaultTheme";
import config from "@/../tailwind.config";

type Breakpoints = Record<string, string>;

const breakpoints = {
  ...defaultTheme.screens,
  ...config.theme.extend?.screens,
} as Breakpoints;

function parseBreakpointValue(screen: string): number {
  return parseInt(screen, 10);
}

const { width } = useWindowSize();

export default function useTailwindBreakpoint() {
  const isBreakpointOrAbove = (breakpoint: string) => {
    const breakpointValue = breakpoints[breakpoint];

    if (!breakpointValue) {
      console.error(`El breakpoint "${breakpoint}" no está definido.`);
      return false;
    }

    const minWidth = parseBreakpointValue(breakpointValue);
    return computed(() => width.value >= minWidth).value;
  };

  return { isBreakpointOrAbove, width };
}
